import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 bg-gray-700/80"
}
const _hoisted_2 = {
  key: 0,
  class: "fixed inset-0 overflow-hidden"
}
const _hoisted_3 = { class: "absolute inset-0 overflow-hidden" }
const _hoisted_4 = { class: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10" }
const _hoisted_5 = { class: "pointer-events-auto relative w-screen max-w-md" }
const _hoisted_6 = { class: "absolute left-0 top-0 -ml-8 flex pr-2 pt-4 sm:-ml-10 sm:pr-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "absolute -inset-2.5" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close panel", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "relative flex h-full flex-col overflow-y-auto bg-[#f9fafb] py-6 shadow-xl px-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold text-gray-900 block" }, "Tjekliste til dit køretøj"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-600 block" }, "Du skal indsende en tjekliste, før du kan fortsætte."),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-600 block" }, "Sæt kun kryds hvis der er fejl.")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-2 text-xs uppercase tracking-wide text-gray-500" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "py-2" }, "Punkt"),
    /*#__PURE__*/_createElementVNode("div", { class: "py-2 text-right" }, "Har fejl")
  ])
], -1)
const _hoisted_14 = { class: "mt-1 flex-1 pb-28" }
const _hoisted_15 = {
  key: 0,
  class: "divide-y divide-gray-200 rounded-md border border-gray-200 bg-white"
}
const _hoisted_16 = { class: "text-sm text-gray-900" }
const _hoisted_17 = { class: "flex justify-end" }
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = {
  key: 1,
  class: "text-sm text-gray-600 p-3"
}
const _hoisted_20 = { class: "absolute inset-x-0 bottom-0 bg-white/95 backdrop-blur border-t border-gray-200" }
const _hoisted_21 = { class: "px-4 py-3 space-y-3" }
const _hoisted_22 = { class: "flex items-center justify-between pb-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-700" }, "Send notifikation til kørselsleder", -1)
const _hoisted_24 = { class: "inline-flex items-center cursor-pointer select-none" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "relative h-6 w-11 rounded-full bg-gray-300 transition-colors peer-checked:bg-primary before:content-[''] before:absolute before:top-0.5 before:left-0.5 before:h-5 before:w-5 before:rounded-full before:bg-white before:transition-transform before:duration-200 before:ease-in-out peer-checked:before:translate-x-[20px]" }, null, -1)

import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'checklistComponent',
  props: {
    isVisible: { type: Boolean }
  },
  setup(__props: any) {

const props = __props
const store = useStore()

const close = () => { store.commit('bookingStore/toggleChecklist') }

// source of truth from store
const checklistForm = computed(() => store.getters['bookingStore/checklistForm'] || store.state.bookingStore.checklistForm)
const items = computed(() => (checklistForm.value?.items ?? []) as Array<{ keyName:string; displayLabel:string; checkpointId:number; sortOrder:number; isRequired:boolean }>)

// dynamic values keyed by KeyName
const values = reactive<Record<string, boolean>>({})
const sendAlarm = ref(false)

const hasAnyFault = computed(() => Object.values(values).some(v => v === true))

// initialize values when items change
watch(items, (arr) => {
  // reset map to only current keys
  const next: Record<string, boolean> = {}
  for (const i of arr) next[i.keyName] = values[i.keyName] ?? false
  // replace contents
  for (const k of Object.keys(values)) delete values[k]
  Object.assign(values, next)
}, { immediate: true })

const submit = async () => {
  await store.dispatch('bookingStore/submitChecklistAndContinue', {
    values: { ...values },
    sendAlarm: sendAlarm.value
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fixed inset-0 z-50", _ctx.isVisible ? 'pointer-events-auto' : 'pointer-events-none']),
    role: "dialog",
    "aria-modal": "true"
  }, [
    _createVNode(_Transition, {
      name: "fade",
      "enter-active-class": "ease-in-out duration-500",
      "leave-active-class": "ease-in-out duration-500",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (_ctx.isVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "slide",
      "enter-active-class": "transform transition ease-in-out duration-500 sm:duration-700",
      "enter-from-class": "translate-x-full",
      "enter-to-class": "translate-x-0",
      "leave-active-class": "transform transition ease-in-out duration-500 sm:duration-700",
      "leave-from-class": "translate-x-0",
      "leave-to-class": "translate-x-full"
    }, {
      default: _withCtx(() => [
        (_ctx.isVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (close())),
                        type: "button",
                        class: "relative rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                      }, _hoisted_10)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _hoisted_13,
                      _createElementVNode("div", _hoisted_14, [
                        (items.value.length)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (i) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: i.checkpointId,
                                  class: "grid grid-cols-2 items-center px-3 py-3"
                                }, [
                                  _createElementVNode("span", _hoisted_16, _toDisplayString(i.displayLabel), 1),
                                  _createElementVNode("span", _hoisted_17, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": ($event: any) => ((values[i.keyName]) = $event),
                                      type: "checkbox",
                                      class: "h-5 w-5 rounded border-gray-300 accent-primary"
                                    }, null, 8, _hoisted_18), [
                                      [_vModelCheckbox, values[i.keyName]]
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_19, " Ingen punkter at udfylde. "))
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createElementVNode("label", _hoisted_24, [
                              _withDirectives(_createElementVNode("input", {
                                disabled: !hasAnyFault.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sendAlarm).value = $event)),
                                type: "checkbox",
                                class: "sr-only peer"
                              }, null, 8, _hoisted_25), [
                                [_vModelCheckbox, sendAlarm.value]
                              ]),
                              _hoisted_26
                            ])
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "w-full rounded-lg bg-primary px-4 py-2 text-white text-sm font-medium hover:opacity-90 active:opacity-95",
                            onClick: submit
                          }, " Indsend tjekliste ")
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})